import { OwaDate } from 'owa-datetime';
import { action } from 'satcheljs';

/**
 * Changes date range to the one including the selected date
 */
export const goToDate = action('goToDate', (selectedDate: OwaDate) => ({ selectedDate }));
